export default "__VITE_ASSET__GYrb5MmC__"